import { create } from "zustand";

interface ClaimFormState {
  bankingInfo: {
    accountHolder: string;
    bankName: string;
    accountName: string;
    accountType: string;
    accountTypeId:string;
    branchCode: string;
    accountNumber: string;
    payableTo: string;
    relationship: string;
    branch: string;
    emailAddress: string;
    passportNumber: string;
    sourceOfFunds: string;
    occupation: string;
    nationality: string;
    countryOfResidence: string;
    countryOfBirth: string;
    submissionDate: string;
    cellPhoneNumber: string;
  };
  setBankingInfo: (data: Partial<ClaimFormState["bankingInfo"]>) => void;
  resetBankingInfo:()=>void;
}

export const useBankFormStore = create<ClaimFormState>((set) => ({
  bankingInfo: {
    accountHolder: "",
    bankName: "",
    accountName: "",
    accountType: "",
    accountTypeId:"",
    branchCode: "",
    accountNumber: "",
    payableTo: "",
    relationship: "",
    branch: "",
    emailAddress: "",
    passportNumber: "",
    sourceOfFunds: "",
    occupation: "",
    nationality: "",
    countryOfResidence: "",
    countryOfBirth: "",
    submissionDate: "2025-07-09",
    cellPhoneNumber: "",
  },
  setBankingInfo: (data) =>
    set((state) => ({
      bankingInfo: { ...state.bankingInfo, ...data },
    })),
    resetBankingInfo:()=>
      set(()=>({
        bankingInfo: {
    accountHolder: "",
    bankName: "",
    accountName: "",
    accountType: "",
    accountTypeId:"",
    branchCode: "",
    accountNumber: "",
    payableTo: "",
    relationship: "",
    branch: "",
    emailAddress: "",
    passportNumber: "",
    sourceOfFunds: "",
    occupation: "",
    nationality: "",
    countryOfResidence: "",
    countryOfBirth: "",
    submissionDate: "2025-07-09",
    cellPhoneNumber: "",
  },
      }))
}));
